// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/Fonts/PPNeueBit-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/Fonts/N27-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../assets/Fonts/N27-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../assets/Fonts/N27-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../assets/Fonts/N27-Medium.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: PP-Nuebit;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: N27;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: N27-Bold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: N27-Light;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: N27-Medium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.course-syllabus-container {
  display: flex;
  flex-direction: column;
  border-top: 1pt solid black;
}

.course-syllabus-container .wrapper {
}

.course-syllabus-container .box-1 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 3rem;
  margin-top: 2rem;
}
.course-syllabus-container .box-1 .box-container {
  display: flex;
  gap: 0.625rem;
}
.course-syllabus-container .box-1 .box {
  border: 1px solid black;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: N27;
  font-weight: 400;
  font-size: 1.25rem;
  height: 2.375rem;
  background-color: #f5f5f5;
  width: 12.75rem;
  cursor: pointer;
}
.course-syllabus-container .box-1 .box.active {
  border: 3px dashed white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: N27;
  font-weight: 400;
  font-size: 1.25rem;
  height: 2.375rem;
  background-color: #000000;
  color: white;
  width: 12.75rem;
}


.course-syllabus-container .box-2 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 4rem;
  padding: 0 3% 0 3%;
}

.course-syllabus-container .box-2 .box-container {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
}

.course-syllabus-container .box-2 .box-container .course-syllabus-left-box {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 50%;
  position: sticky;
  margin-right: 7rem;
  margin-left: 3rem;
}
 .course-syllabus-container .box-2 .box-container .course-syllabus-left-box .course-outline-box1{
  margin-top: 1rem;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; 
  min-height: 42rem; /* Internet Explorer 10+*/ 
} 
.course-outline-box{
  display: flex;
  flex-direction: column;
  min-height:35rem;
  width:28.75rem;
  justify-content: flex-start;
  align-items: center; 
  max-height: 100%;

}
.course-outline-box::after {
  content: '';
  position: absolute;
  min-height:40rem;
  margin-top: 3rem;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none; /* Allows clicking through the overlay */
  background: linear-gradient(to bottom, rgba(55, 55, 55, 0), rgba(255, 255, 255, 1));
  z-index: 1;
}

.course-outline-box::-webkit-scrollbar {
  display: none;
}
.vector-big-container{
  display: flex;
  justify-content: center;
  align-items: center;

  position: absolute; 
  bottom: 20px; 
  left: 23%; 
  height: 100%;
  z-index: 10;
}
.course-syllabus-container .box-2 .box-container .course-syllabus-left-box .course-outline-box .component{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  width: 95%;
  height:8.75rem;
  margin-bottom: 3rem;
  padding-left: 1rem;
  position: relative;
  z-index: 0;
}
.selected-component {
  position: relative !important;
  z-index: 2 !important; 
}
.course-syllabus-container .box-2 .box-container .course-syllabus-left-box .course-outline-box .component .bullet{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height:3.5rem;
  width:2.5rem;
  margin-left: 0.55rem;
  margin-bottom: 1rem;
  cursor: pointer;
}
.new-bullet {
  position: relative;
  right: 13.7px;
  
}
.course-syllabus-container .box-2 .box-container .course-syllabus-left-box .course-outline-box .component .component-content{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
  width:90%;
}
.component-title-box{
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 0.3rem;
  cursor: pointer;
}
.component-title{
  font-family: N27-Bold;
  font-size:2.813rem ;
  text-align: left;

}
.component-description-box{
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 1.313rem;
}
.component-description{
  font-family: N27-Light;
  font-size:1.25rem ;
  text-align: left;
  font-weight: 300;
}
.completed{
  position: relative !important;
  z-index: 2 !important; 

}
.completed-label{
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.join-button-container{
  display: flex;
  width:100%;
  height:4.375rem;
  justify-content:flex-start;
  align-items: center;
  z-index: 12;
  cursor: pointer;
}

.course-syllabus-container .box-2 .box-container .right-box {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  width: 50%;
  margin-left: 7rem;
  position: sticky;
  top:3rem;
}

.course-syllabus-container .box-2 .box-container .right-box .course-box {
  border: 1px solid black;
  width: 35.375rem;
  min-height: 39.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.course-syllabus-container .box-2 .box-container .right-box .course-box .box {
  width: 95%;
  height: 95%;
  display: flex; 
  flex-direction: column;
  justify-content: space-between;

}
.course-text-container{
  display: flex;
  margin-top: 1rem;
  margin-bottom: 1rem;

}

.course-syllabus-container
  .box-2
  .box-container
  .right-box
  .course-box
  .course-text {
  font-size: 3rem;
  font-weight: 700;
  font-family: PP NeueBit;
  text-align: left;
}
.course-level-box-container{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

}
.course-syllabus-container
  .box-2
  .box-container
  .right-box
  .course-box
  .box
  .course-level-box {
  width: 100%;
  position: relative;
  border: 1px solid black;
  min-height: 8.75rem;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
}

.course-syllabus-container
  .box-2
  .box-container
  .right-box
  .course-box
  .box
  .course-level-box
  .task-box {
  display: flex;
  justify-content: space-between;
}
.course-syllabus-container
  .box-2
  .box-container
  .right-box
  .course-box
  .box
  .course-level-box
  .task-box
  .progress-text {
  font-size: 1.25rem;
  font-weight: 400;
  font-family: N27;

}

.course-syllabus-container
  .box-2
  .box-container
  .right-box
  .course-box
  .box
  .course-level-box
  .task-box
  .b-1-container {
  display: flex;
  gap: 1rem;
}

.course-syllabus-container
  .box-2
  .box-container
  .right-box
  .course-box
  .box
  .course-level-box
  .task-box

  .b-1 {
  background-color: #e0e0e0;
  min-width: 4.063rem;
  height: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  font-weight: 400;
  font-family: N27;
  padding: 0 0.5rem 0 0.5rem;
}
.course-syllabus-container
  .box-2
  .box-container
  .right-box
  .course-box
  .box
  .course-level-box
  .course-level-box-label {
  position: absolute;
  top: 0;
  right: 0;
  font-family: N27;
  background-color: #15b525;
  font-size: 1rem;
  color: white;
  font-weight: 400;
  padding: 0.5rem 0.625rem 0.5rem 0.625rem;
}
.course-syllabus-container
  .box-2
  .box-container
  .right-box
  .course-box
  .box
  .course-level-box
  .course-level-inner-box {
  width: 95%;
  min-height: 80%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 2% 2% 2%;
  cursor: pointer;
}
.header-text-container{
  display: flex;
  width: 83%;
  margin: 0.5rem 0 0.5rem 0;
  cursor: pointer;
}
.course-level-box .course-level-inner-box .header-text {
  text-align: left;
  font-size: 2rem;
  font-family: N27-Medium;
  font-weight: 500;
}
.para-text-container{
  display: flex;
  margin-bottom: 0.5rem;
}
.course-level-box .course-level-inner-box .para-text {
  text-align: left;
  font-size: 1rem;
  font-family: N27-Light;
  font-weight: 300;
}
.course-syllabus-container
  .box-2
  .box-container
  .right-box
  .course-box
  .box
  .course-level-box
  .course-level-progress {
  border: 2px solid #15b525;
  position: absolute;
  bottom: 0;
}
.yet-to-start-container{
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.yet-to-start{
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-left: 0.5rem;
}
.yet-to-start-text{
  font-family: N27;
  font-size: 1.25rem;
  text-align: left;
  color: #434343;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Course/CourseSyllabus.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,4CAAoD;AACtD;AACA;EACE,gBAAgB;EAChB,4CAAiD;AACnD;AACA;EACE,qBAAqB;EACrB,4CAA8C;AAChD;AACA;EACE,sBAAsB;EACtB,4CAA+C;AACjD;AACA;EACE,uBAAuB;EACvB,4CAAgD;AAClD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;AACA;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;CACC;EACC,gBAAgB;EAChB,qBAAqB,EAAE,YAAY;EACnC,wBAAwB;EACxB,iBAAiB,EAAE,yBAAyB;AAC9C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;;AAElB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oBAAoB,EAAE,wCAAwC;EAC9D,mFAAmF;EACnF,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,aAAa;;AAEf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;EACZ,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;;AAElB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,qBAAqB;;AAEvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,UAAU;EACV,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;;EAEnB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,8BAA8B;;AAEhC;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;;AAErB;;AAEA;;;;;;EAME,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;;AAErB;AACA;;;;;;;EAOE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;;;;;;EAQE,aAAa;EACb,8BAA8B;AAChC;AACA;;;;;;;;;EASE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;;AAElB;;AAEA;;;;;;;;;EASE,aAAa;EACb,SAAS;AACX;;AAEA;;;;;;;;;;EAUE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;;;;;;;;EAQE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,wCAAwC;AAC1C;AACA;;;;;;;;EAQE,UAAU;EACV,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,UAAU;EACV,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;AACA;;;;;;;;EAQE,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX","sourcesContent":["@font-face {\n  font-family: PP-Nuebit;\n  src: url(\"../../../assets/Fonts/PPNeueBit-Bold.otf\");\n}\n@font-face {\n  font-family: N27;\n  src: url(\"../../../assets/Fonts/N27-Regular.otf\");\n}\n@font-face {\n  font-family: N27-Bold;\n  src: url(\"../../../assets/Fonts/N27-Bold.otf\");\n}\n@font-face {\n  font-family: N27-Light;\n  src: url(\"../../../assets/Fonts/N27-Light.otf\");\n}\n@font-face {\n  font-family: N27-Medium;\n  src: url(\"../../../assets/Fonts/N27-Medium.otf\");\n}\n\n.course-syllabus-container {\n  display: flex;\n  flex-direction: column;\n  border-top: 1pt solid black;\n}\n\n.course-syllabus-container .wrapper {\n}\n\n.course-syllabus-container .box-1 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 3rem;\n  margin-top: 2rem;\n}\n.course-syllabus-container .box-1 .box-container {\n  display: flex;\n  gap: 0.625rem;\n}\n.course-syllabus-container .box-1 .box {\n  border: 1px solid black;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-family: N27;\n  font-weight: 400;\n  font-size: 1.25rem;\n  height: 2.375rem;\n  background-color: #f5f5f5;\n  width: 12.75rem;\n  cursor: pointer;\n}\n.course-syllabus-container .box-1 .box.active {\n  border: 3px dashed white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-family: N27;\n  font-weight: 400;\n  font-size: 1.25rem;\n  height: 2.375rem;\n  background-color: #000000;\n  color: white;\n  width: 12.75rem;\n}\n\n\n.course-syllabus-container .box-2 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 4rem;\n  padding: 0 3% 0 3%;\n}\n\n.course-syllabus-container .box-2 .box-container {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.course-syllabus-container .box-2 .box-container .course-syllabus-left-box {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  width: 50%;\n  position: sticky;\n  margin-right: 7rem;\n  margin-left: 3rem;\n}\n .course-syllabus-container .box-2 .box-container .course-syllabus-left-box .course-outline-box1{\n  margin-top: 1rem;\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; \n  min-height: 42rem; /* Internet Explorer 10+*/ \n} \n.course-outline-box{\n  display: flex;\n  flex-direction: column;\n  min-height:35rem;\n  width:28.75rem;\n  justify-content: flex-start;\n  align-items: center; \n  max-height: 100%;\n\n}\n.course-outline-box::after {\n  content: '';\n  position: absolute;\n  min-height:40rem;\n  margin-top: 3rem;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  pointer-events: none; /* Allows clicking through the overlay */\n  background: linear-gradient(to bottom, rgba(55, 55, 55, 0), rgba(255, 255, 255, 1));\n  z-index: 1;\n}\n\n.course-outline-box::-webkit-scrollbar {\n  display: none;\n}\n.vector-big-container{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  position: absolute; \n  bottom: 20px; \n  left: 23%; \n  height: 100%;\n  z-index: 10;\n}\n.course-syllabus-container .box-2 .box-container .course-syllabus-left-box .course-outline-box .component{\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-start;\n  width: 95%;\n  height:8.75rem;\n  margin-bottom: 3rem;\n  padding-left: 1rem;\n  position: relative;\n  z-index: 0;\n}\n.selected-component {\n  position: relative !important;\n  z-index: 2 !important; \n}\n.course-syllabus-container .box-2 .box-container .course-syllabus-left-box .course-outline-box .component .bullet{\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  height:3.5rem;\n  width:2.5rem;\n  margin-left: 0.55rem;\n  margin-bottom: 1rem;\n  cursor: pointer;\n}\n.new-bullet {\n  position: relative;\n  right: 13.7px;\n  \n}\n.course-syllabus-container .box-2 .box-container .course-syllabus-left-box .course-outline-box .component .component-content{\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  height: 100%;\n  width:90%;\n}\n.component-title-box{\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  margin-bottom: 0.3rem;\n  cursor: pointer;\n}\n.component-title{\n  font-family: N27-Bold;\n  font-size:2.813rem ;\n  text-align: left;\n\n}\n.component-description-box{\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  margin-bottom: 1.313rem;\n}\n.component-description{\n  font-family: N27-Light;\n  font-size:1.25rem ;\n  text-align: left;\n  font-weight: 300;\n}\n.completed{\n  position: relative !important;\n  z-index: 2 !important; \n\n}\n.completed-label{\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n.join-button-container{\n  display: flex;\n  width:100%;\n  height:4.375rem;\n  justify-content:flex-start;\n  align-items: center;\n  z-index: 12;\n  cursor: pointer;\n}\n\n.course-syllabus-container .box-2 .box-container .right-box {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n\n  width: 50%;\n  margin-left: 7rem;\n  position: sticky;\n  top:3rem;\n}\n\n.course-syllabus-container .box-2 .box-container .right-box .course-box {\n  border: 1px solid black;\n  width: 35.375rem;\n  min-height: 39.25rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.course-syllabus-container .box-2 .box-container .right-box .course-box .box {\n  width: 95%;\n  height: 95%;\n  display: flex; \n  flex-direction: column;\n  justify-content: space-between;\n\n}\n.course-text-container{\n  display: flex;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n\n}\n\n.course-syllabus-container\n  .box-2\n  .box-container\n  .right-box\n  .course-box\n  .course-text {\n  font-size: 3rem;\n  font-weight: 700;\n  font-family: PP NeueBit;\n  text-align: left;\n}\n.course-level-box-container{\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n\n}\n.course-syllabus-container\n  .box-2\n  .box-container\n  .right-box\n  .course-box\n  .box\n  .course-level-box {\n  width: 100%;\n  position: relative;\n  border: 1px solid black;\n  min-height: 8.75rem;\n  margin-bottom: 1rem;\n  display: flex;\n  flex-direction: column;\n}\n\n.course-syllabus-container\n  .box-2\n  .box-container\n  .right-box\n  .course-box\n  .box\n  .course-level-box\n  .task-box {\n  display: flex;\n  justify-content: space-between;\n}\n.course-syllabus-container\n  .box-2\n  .box-container\n  .right-box\n  .course-box\n  .box\n  .course-level-box\n  .task-box\n  .progress-text {\n  font-size: 1.25rem;\n  font-weight: 400;\n  font-family: N27;\n\n}\n\n.course-syllabus-container\n  .box-2\n  .box-container\n  .right-box\n  .course-box\n  .box\n  .course-level-box\n  .task-box\n  .b-1-container {\n  display: flex;\n  gap: 1rem;\n}\n\n.course-syllabus-container\n  .box-2\n  .box-container\n  .right-box\n  .course-box\n  .box\n  .course-level-box\n  .task-box\n\n  .b-1 {\n  background-color: #e0e0e0;\n  min-width: 4.063rem;\n  height: 1.5rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1rem;\n  font-weight: 400;\n  font-family: N27;\n  padding: 0 0.5rem 0 0.5rem;\n}\n.course-syllabus-container\n  .box-2\n  .box-container\n  .right-box\n  .course-box\n  .box\n  .course-level-box\n  .course-level-box-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  font-family: N27;\n  background-color: #15b525;\n  font-size: 1rem;\n  color: white;\n  font-weight: 400;\n  padding: 0.5rem 0.625rem 0.5rem 0.625rem;\n}\n.course-syllabus-container\n  .box-2\n  .box-container\n  .right-box\n  .course-box\n  .box\n  .course-level-box\n  .course-level-inner-box {\n  width: 95%;\n  min-height: 80%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 0 2% 2% 2%;\n  cursor: pointer;\n}\n.header-text-container{\n  display: flex;\n  width: 83%;\n  margin: 0.5rem 0 0.5rem 0;\n  cursor: pointer;\n}\n.course-level-box .course-level-inner-box .header-text {\n  text-align: left;\n  font-size: 2rem;\n  font-family: N27-Medium;\n  font-weight: 500;\n}\n.para-text-container{\n  display: flex;\n  margin-bottom: 0.5rem;\n}\n.course-level-box .course-level-inner-box .para-text {\n  text-align: left;\n  font-size: 1rem;\n  font-family: N27-Light;\n  font-weight: 300;\n}\n.course-syllabus-container\n  .box-2\n  .box-container\n  .right-box\n  .course-box\n  .box\n  .course-level-box\n  .course-level-progress {\n  border: 2px solid #15b525;\n  position: absolute;\n  bottom: 0;\n}\n.yet-to-start-container{\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n.yet-to-start{\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  margin-left: 0.5rem;\n}\n.yet-to-start-text{\n  font-family: N27;\n  font-size: 1.25rem;\n  text-align: left;\n  color: #434343;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
